import { useAuth } from "../../shared/AuthContext";
import { useAsync } from "react-use";
import { ErrorDisplay, Loading, usePageTitle } from "../../shared/utils";
import { Box, Group, Stack, Divider } from "@mantine/core";
import { UserMetadata, AuthStatus } from "./ProfileBlock";
import StudentContactsBlock from "./StudentContactsBlock";
import RolesGroups from "./PlatformsBlock";
import SubjectsBlock from "./SubjectsBlock";

export function Profile() {
  usePageTitle("Профиль");

  const auth = useAuth();
  const { value: identity, error, loading } = useAsync(() => auth.identity(), [auth]);

  if (error) {
    return <ErrorDisplay error={error} />
  }
  if (loading || !identity) {
    return <Loading />
  }

  const { profile } = identity;

  return (
    <Box component="main" p="xl">
      <Box maw={1040} mx="auto">
        <Group align="flex-start" gap={64} wrap="wrap">
          {/* Left: identity + subjects */}
          <Box style={{ flex: 1, minWidth: 300 }}>
            <UserMetadata profile={profile} />
            <SubjectsBlock />
          </Box>

          {/* Right: authorization, read-only roles/groups, editable contacts */}
          <Stack w={300} gap="lg" style={{ flexShrink: 0 }}>
            <AuthStatus />
            <Divider />
            <RolesGroups profile={profile} />
            <Divider />
            <StudentContactsBlock profile={profile} />
          </Stack>
        </Group>
      </Box>
    </Box>
  );
}
